import { AsyncPipe, CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective, MaskitoPipe } from '@maskito/angular';

import { MiscModule } from '../../misc/misc.module';
import { DebugPageRoutingModule } from './debug-routing.module';
import { DebugPageComponent } from './debug.page';
import { BooleanToEnabledDirective } from './directives/boolean-to-enabled.directive';
import { BooleanToYesDirective } from './directives/boolean-to-yes.directive';

@NgModule({
  declarations: [DebugPageComponent, BooleanToEnabledDirective, BooleanToYesDirective],
  imports: [
    CommonModule,
    AsyncPipe,
    FormsModule,
    IonicModule,
    DebugPageRoutingModule,
    ReactiveFormsModule,
    MaskitoDirective,
    MiscModule,
    MaskitoPipe,
    NgOptimizedImage
  ]
})
export class DebugPageModule {}
